'use strict';

exports.__esModule = true;
exports.default = {
  SOCIAL: 'social',
  REVERSE_TIME: 'reverse_time',
  TIME: 'time'
};
//# sourceMappingURL=CommentsOrderBy.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-facebook/lib/constants/CommentsOrderBy.js
// module id = 131
// module chunks = 95715928098905 172441821870073 232727283551173